export default "__VITE_ASSET__CO$sSFB2__"